<template>
  <v-main>
    <MainNavigationBar />
    <error-dialog />
    <slot />
  </v-main>
</template>

<script>
import MainNavigationBar from "@/components/MainNavigationBar.vue";
import ErrorDialog from "@/components/ErrorDialog.vue";

export default {
  name: "MainWithoutFooterLayout",
  components: {
    MainNavigationBar,
    ErrorDialog,
  },
};
</script>
